import React from "react";
import { withRouter } from "react-router-dom";
import { withGeneral } from "../../context/mixin/with-general";
import { FaqsContainer } from "../faqs-ocaso/faqs-style";
import FaqsServices from "../../services/FaqsServices";
import Title02Text from "../../components/components-text/title-02-text";

interface FaqsProps { }

interface FaqsState {
  faqsMutua: any[],
  loading: boolean,
  error: boolean,
}

class FaqsLayout extends React.Component<FaqsProps, FaqsState> {

  state = {
    faqsMutua: [],
    loading: true,
    error: false
  };

  componentDidMount() {
    this.getFAQsMutua();
  }

  getFAQsMutua = async () => {
    const args = {
      loader: false,
      setLoading: () => {}
    };

    const faqsMutua = await FaqsServices.getFAQsMutua(args);
    if (faqsMutua.error) {
      this.setState({ error: true, loading: false });
      return;
    }
   
    this.setState({ faqsMutua, loading: false });
  }

  render() {
    const { faqsMutua, loading, error } = this.state;

    return (
      <FaqsContainer>
        <Title02Text>Preguntas Frecuentes</Title02Text>
        
        { faqsMutua.length > 0 && 
          <>
            <div className="faq-index">
              <p className="title">Índice</p>
              <ul>
                {faqsMutua.map((faq:any) => 
                  <li key={`faq-index-${faq.faq_mutua_order}`}>
                  <a href={`#faq-mutua-${faq.faq_mutua_order}`}>{faq.faq_mutua_order}. {faq.faq_mutua_title}</a>           
                  </li>   
                )}
              </ul>
            </div>

            <div className="faq-list">
              { faqsMutua.map((faq:any) =>
                <div key={`faq-list-${faq.faq_mutua_order}`} id={`faq-mutua-${faq.faq_mutua_order}`} className="faq-scroll">
                  <p className="title">{faq.faq_mutua_order}. {faq.faq_mutua_title}</p>
                  <div className="content" dangerouslySetInnerHTML={{__html: faq.faq_mutua_content}}/>
                </div>
              )}
            </div>
          </>
        }

        { !loading && !error && faqsMutua.length === 0 && <p className="info-text">No hay información disponible para mostrar. Inténtelo más tarde.</p> }

        { error && <p className="info-text">No se ha podido recuperar la información solicitada. Inténtelo más tarde.</p>}

      </FaqsContainer>
    );
  }
}

export default withRouter(withGeneral(FaqsLayout));
